import styled from '@emotion/styled';

export const RowContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
	width: 100%;
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-self: flex-start;
	width: 100%;
	overflow: auto;
	max-height: 80dvh;
`;

export const ArrowContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;

	> .icon {
		font-size: 5rem !important;
	}
`;

export const Line = styled.div`
	display: flex;
	width: 1px;
	height: 100%;
	background-color: var(--black-40);
	margin: 2rem 0;
`;

export const ActionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	height: 100%;
	gap: 2rem;
	padding: 1rem;
	overflow: auto;
	max-height: 80dvh;
`;

export const DndContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
`;

export const DndIconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	width: 4rem;

	> .icon:hover {
		cursor: move;
	}
`;

export const RemoveButtonContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
`;
